interface Props {
  userLimits: {
    postCount: number | null
    replyCount: number | null
    userInfoChangeCount: number | null
  }
}

const UserLimits: React.FC<Props> = ({ userLimits }) => {
  return (
    <div className="bgd-theme border-theme mb-[10px] flex h-auto w-full flex-col border py-[15px] pl-[25px]">
      <div className="flex">
        <div className="w-1/2 font-semibold italic">
          <h1>Usage limits:</h1>
          <p>Posts:</p>
          <p>Replies:</p>
          <p>Edit Profile Change:</p>
        </div>
        <div className="w-1/4">
          <h1 className="font-semibold italic">Max:</h1>
          <p>10</p>
          <p>20</p>
          <p>10</p>
        </div>
        <div className="w-1/4">
          <h1 className="font-semibold italic">Current:</h1>
          <p>{userLimits.postCount ? userLimits.postCount : 0}</p>
          <p>{userLimits.replyCount ? userLimits.replyCount : 0}</p>
          <p>
            {userLimits.userInfoChangeCount
              ? userLimits.userInfoChangeCount
              : 0}
          </p>
        </div>
      </div>
      <p className="text-sub pt-[5px] italic">
        ***These are put in place to limit app traffic
      </p>
    </div>
  )
}

export default UserLimits
